// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1453dba5","977":"89b86c5b"}[chunkId] + ".chunk.js";
};